(function (Drupal, $, once) {
  Drupal.behaviors.tables = {
    attach: function (context) {
      $(function () {
        //table horizontal scroll
        once('table-init', 'table', context).forEach(function (tableElement) {
          var $this = $(tableElement);
          var wrapper1 = $this.parent();
          if (!wrapper1.hasClass("table-wrapper")) {
            $this.wrap('<div class="table-wrapper"></div>');
          }
        });

        once('table-special-init', '.table-special', context).forEach(function (specialTableElement) {
          var $this = $(specialTableElement);
          var options = ["G;", "R;", "Y;"];
          $this.find("td:not(:first-child)").each(function () {
            var token = $(this).text().slice(0, 2).toUpperCase();
            $(this).text($(this).text().slice(2));
            if (options.includes(token)) {
              var color;
              switch (token.toUpperCase()) {
                case "G;":
                  color = "green";
                  break;
                case "R;":
                  color = "red";
                  break;
                case "Y;":
                  color = "yellow";
                  break;
                default:
                  color = "none";
              }
              $(this).wrapInner(
                `<div class="status-elem color-${color}"></div>`
              );
            }
          });
        });
      });
    },
  };
})(Drupal, jQuery, once);
